!(function (e) {
  var t,
    n,
    o,
    i,
    c,
    d =
      '<svg><symbol id="icon-s" viewBox="0 0 1024 1024"><path d="M509.09548927 497.5392456h15.4495244c14.21356225-78.54537987 23.85406518-128.47824097 28.98330664-149.67498755 12.85400367-52.15759253 34.73052954-95.9106443 65.62957764-131.32095385 39.30358887-36.70806885 77.86560059-55.00030541 115.87142944-55.0003047 27.06756592 0 47.9553225 9.26971435 62.78686547 27.93273879 15.44952368 18.04504371 23.17428589 43.44406104 23.17428589 76.32064843 0 61.79809547-21.25854516 119.70291161-63.7138369 173.77624488-42.51708961 54.07333398-94.98367286 89.1746521-157.39974976 105.24215722-13.53378296 78.54537987-35.10131812 141.02325463-64.7026062 187.37182641-40.53955102 63.03405762-94.921875 94.55108643-163.14697266 94.55108643-40.60134888 0-75.02288843-12.85400367-103.32641578-38.56201172-22.55630517-20.64056373-33.80355811-38.31481958-33.80355882-53.14636255 0-10.25848365 6.42700219-22.18551659 19.28100586-35.71929955 13.53378296-14.15176368 23.48327661-21.25854516 29.97207665-21.25854445 5.12924218 0 16.06750512 14.21356225 32.75299096 42.51708961 16.80908227 28.30352807 37.69683814 42.51708961 62.78686476 42.51708961 31.51702881 0 59.26437401-17.7360537 83.05664062-53.14636184 23.85406518-35.41030883 41.83731103-85.59036278 54.07333398-150.6019597-53.39355469 0-97.51739502-14.21356225-132.24792456-42.51708961-34.79232812-28.30352807-52.15759253-64.02282691-52.15759325-107.15789794 0-27.68554664 4.14047217-49.25308252 12.54501367-64.7026062 10.93826294-19.96078515 28.30352807-29.97207666 52.15759253-29.97207666 18.66302514 0 27.99453735 5.19104004 27.99453735 15.44952441 0 5.19104004-4.82025146 21.25854516-14.52255225 48.32611036-4.51126075 12.23602295-6.73599219 23.48327661-6.73599219 33.80355882 0 24.41024804 9.64050293 44.74182105 28.98330664 60.80932617 19.96078515 16.06750512 45.35980249 24.10125732 76.25884987 24.10125733z m104.31518578-52.15759253l-3.89328003 33.80355811c38.62380958-18.66302514 71.12960839-47.64633179 97.51739501-86.94992065 27.06756592-39.24179101 40.53955102-79.78134131 40.53955103-121.61865235 0-26.38778663-9.26971435-39.55078102-27.99453736-39.550781-21.19674659 0-39.55078102 11.86523438-55.00030541 35.65750097-23.17428589 34.79232812-40.23056031 94.30389428-51.16882324 178.59649635z"  ></path></symbol></svg>',
    s = (s = document.getElementsByTagName("script"))[
      s.length - 1
    ].getAttribute("data-injectcss"),
    l = function (e, t) {
      t.parentNode.insertBefore(e, t);
    };
  if (s && !e.__iconfont__svg__cssinject__) {
    e.__iconfont__svg__cssinject__ = !0;
    try {
      document.write(
        "<style>.svgfont {display: inline-block;width: 1em;height: 1em;fill: currentColor;vertical-align: -0.1em;font-size:16px;}</style>"
      );
    } catch (e) {
      console && console.log(e);
    }
  }
  function a() {
    c || ((c = !0), o());
  }
  function r() {
    try {
      i.documentElement.doScroll("left");
    } catch (e) {
      return void setTimeout(r, 50);
    }
    a();
  }
  (t = function () {
    var e, t;
    ((t = document.createElement("div")).innerHTML = d),
      (d = null),
      (e = t.getElementsByTagName("svg")[0]) &&
        (e.setAttribute("aria-hidden", "true"),
        (e.style.position = "absolute"),
        (e.style.width = 0),
        (e.style.height = 0),
        (e.style.overflow = "hidden"),
        (t = e),
        (e = document.body).firstChild ? l(t, e.firstChild) : e.appendChild(t));
  }),
    document.addEventListener
      ? ~["complete", "loaded", "interactive"].indexOf(document.readyState)
        ? setTimeout(t, 0)
        : ((n = function () {
            document.removeEventListener("DOMContentLoaded", n, !1), t();
          }),
          document.addEventListener("DOMContentLoaded", n, !1))
      : document.attachEvent &&
        ((o = t),
        (i = e.document),
        (c = !1),
        r(),
        (i.onreadystatechange = function () {
          "complete" == i.readyState && ((i.onreadystatechange = null), a());
        }));
})(window);
